import React, { useEffect, useRef, useState } from "react"
import DataTable from "react-data-table-component"
import { ChevronDown, ChevronLeft, ChevronRight, Edit, Trash } from "react-feather"
import ReactPaginate from "react-paginate"
import classNames from "classnames"

import "../../assets/scss/plugins/extensions/react-paginate.scss"
import "../../assets/scss/pages/data-list.scss"
import fetchApi from "../../utility/context/fetchApi"
import { connect } from "react-redux"
import { coinSelector, tokenSelector } from "../../redux/selectors"
import DataListSidebar from "./CoinsDataListSidebar"
import { comparators, CustomHeader, getSliceData, getSortIndex, getTotalPages, typeNumber, typeString } from "./utils"
import { setCoins } from "../../redux/actions"
import BasicSweetCallback from "../../extensions/sweet-alert/SweetAlertCallback"

const ActionsComponent = ({ row, editRow, deleteRow }) => {
    return (
        <div className="data-list-action minus-6">
            <Edit
                className="cursor-pointer control-icon"
                size={20}
                onClick={() => {
                    return editRow(row)
                }}
            />
            <Trash
                className="cursor-pointer control-icon"
                size={20}
                onClick={() => {
                    deleteRow(row)
                }}
            />
        </div>
    )
}

function Coins(props) {
    const [data, setData] = useState([])
    const [total, setTotal] = useState(1)
    const [page, setPage] = useState(0)
    const [limit, setLimit] = useState(4)
    const [totalPages, setTotalPages] = useState(1)
    const [sortIndex, setSortIndex] = useState([1, 2])
    const [sidebar, setSidebar] = useState(false)
    const [currentData, setCurrentData] = useState(null)
    const [filter, setFilter] = useState('')
    const [sort, setSort] = useState({ selector: 'sortIndex', type: 'asc', typeData: typeNumber })

    useEffect(() => {
        const allDataSorted = props.totalData.slice().sort(comparators[sort.typeData](sort.selector))
        if (sort.type === 'desc') allDataSorted.reverse()
        if (filter) {
            const filteredData = allDataSorted.filter(({ nameFull }) => nameFull.toLowerCase().includes(filter.toLowerCase()))
            setData(filteredData)
            setTotal(filteredData.length)
            setTotalPages(1)
            setPage(0)
            setSortIndex([1, filteredData.length])
        } else {
            setData(getSliceData(allDataSorted, page, limit))
            setTotal(allDataSorted.length)
            setTotalPages(getTotalPages(allDataSorted, limit))
            setSortIndex(getSortIndex(page, limit, allDataSorted.length))
        }
    }, [page, props.totalData, limit, filter, sort, props.token])

    const handleLimit = (limit) => {
        setPage(0)
        setLimit(limit)
    }

    const handleSort = ({ selector, type: typeData }, type) => {
        setSort({ selector, type, typeData })
    }

    const cancelSidebar = () => {
        setSidebar(false)
        setCurrentData(null)
    }

    const addData = (data) => {
        fetchApi({
            url: '/coin',
            method: 'POST',
            token: props.token,
            body: data
        }).then((doc) => {
            props.setCoins([doc, ...props.totalData])
            setPage(0)
            setCurrentData(null)
        })
    }

    const updateData = ({ _id, ...data }) => {
        fetchApi({
            url: `/coin/${_id}`,
            method: 'PATCH',
            token: props.token,
            body: data
        }).then((res) => {
            props.setCoins(props.totalData.map((node) => {
                if (node._id === res._id) return res
                return node
            }))
            setCurrentData(null)
        })
    }

    const removeData = ({ _id }) => {
        fetchApi({
            url: `/coin/${_id}`,
            method: 'DELETE',
            token: props.token,
        }).then(() => {
            props.setCoins(props.totalData.filter((node) =>
                node._id !== _id
            ))
        })
    }

    const columns = [
        {
            name: "Name",
            type: typeString,
            selector: "nameFull",
            sortable: true,
            grow: 1
        },
        {
            name: "Short",
            type: typeString,
            selector: "nameShort",
            sortable: true,
            grow: 1
        },
        {
            name: "Address",
            type: typeString,
            selector: "address",
            sortable: true,
            grow: 1
        },
        {
            name: "Index",
            type: typeNumber,
            selector: "index",
            sortable: true,
            grow: 1
        },
        {
            name: "Sort",
            type: typeNumber,
            selector: "sortOrder",
            sortable: true,
            grow: 1
        },
        {
            name: "Actions",
            maxWidth: '100px',
            cell: row => (
                <ActionsComponent
                    row={row}
                    editRow={(row) => {
                        setCurrentData(row)
                        setSidebar(true)
                    }}
                    deleteRow={(row) => refAlert.current.show(row)}
                />
            )
        }
    ]
    const refAlert = useRef()

    return <div className={`data-list list-view`}>
        <BasicSweetCallback refAlert={refAlert}  onConfirm={(row) => {
                    removeData(row)
                }}/>
        <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationComponent={() => (
                <ReactPaginate
                    previousLabel={<ChevronLeft size={15} />}
                    nextLabel={<ChevronRight size={15} />}
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={totalPages}
                    containerClassName="vx-pagination separated-pagination pagination-end pagination-sm mb-0 mt-2"
                    activeClassName="active"
                    initialPage={page}
                    onPageChange={page => setPage(page.selected)}
                />
            )}
            noHeader
            subHeader
            responsive
            pointerOnHover
            sortIcon={<ChevronDown />}
            sortServer
            onSort={handleSort}
            subHeaderComponent={
                <CustomHeader
                    handleSidebar={setSidebar}
                    handleFilter={(value) => setFilter(value)}
                    handleRowsPerPage={handleLimit}
                    rowsPerPage={limit}
                    total={total}
                    index={sortIndex}
                />
            }
        />
        <DataListSidebar
            show={sidebar}
            data={currentData}
            updateData={updateData}
            addData={addData}
            cancelSidebar={cancelSidebar}
        />
        <div
            className={classNames("data-list-overlay", {
                show: sidebar
            })}
            onClick={cancelSidebar}
        />
    </div>
}

const mapStateToProps = state => {
    return {
        totalData: coinSelector(state),
        token: tokenSelector(state)
    }
}

export default connect(mapStateToProps, { setCoins })(Coins)
